import React, { createContext, useContext, ReactNode } from 'react'

interface LessonContextType {
  lessonId: string
}

const LessonContext = createContext<LessonContextType | undefined>(undefined)

export const LessonProvider: React.FC<{ lessonId: string; children: ReactNode }> = ({ 
  lessonId, 
  children 
}) => {
  return (
    <LessonContext.Provider value={{ lessonId }}>
      {children}
    </LessonContext.Provider>
  )
}

export const useLesson = (): LessonContextType => {
  const context = useContext(LessonContext)
  if (!context) {
    throw new Error('useLesson must be used within a LessonProvider')
  }
  return context
} 